import pre from './pre';
import cart from './cart.vue';
import config from '@/plans/CONCURRENCY_MEETING_BASIC/config/index.jsx';
import success from '@/plans/CONCURRENCY_MEETING_BASIC/success.vue';
import { planTypes } from '@/common/constants';

export default {
    pre,
    components: {
        config: config(planTypes.CONCURRENT_MEETING_PLUS),
        cart,
        success
    },
    post: () => { },
}
